module.exports = __webpack_public_path__ + "static/docker-71f86c727da46b91e346b5a042582c09.svg";